import type { UserJobPosting } from '@openclassrooms/sdk-web';

import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

interface GetUserJobPostingParams {
  userId: string;
  jobPostingId: string;
}

const { useGet: useUserJobPosting } = getCRUDHooks<UserJobPosting[], GetUserJobPostingParams>({
  entityName: 'userJobPosting',
  get: ({ userId, jobPostingId }: GetUserJobPostingParams) =>
    clientApi.getOCClient().helpers.user.users.id(userId).jobPostings.get(jobPostingId),
});

// eslint-disable-next-line import/prefer-default-export
export { useUserJobPosting };
